module.exports = __webpack_public_path__ + "8db74a0815fa64fa2cc71c68de6f1cca.png";